module.exports = __webpack_public_path__ + "media/rendering/renderingSlide6-dbe90938.png";